import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useWorkspace } from '../../context/WorkspaceContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const { workspaces, isClient, loading: workspaceLoading } = useWorkspace();
  const location = useLocation();

  if (authLoading || (user && workspaceLoading)) {
    return null;
  }

  if (!user) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  if (user && workspaces.length === 0) {
    return <Navigate to="/login?error=no_workspace" replace />;
  }

  // Clients must only access client routes. Redirect them if they try to access any main-app route.
  const clientAllowedRoutes = ['/dashboard', '/projects', '/inbox', '/proposals', '/support', '/account-settings'];
  const isClientRoute = clientAllowedRoutes.some(route => location.pathname === route || location.pathname.startsWith(`${route}/`));
  
  if (isClient && !isClientRoute) {
    return <Navigate to="/dashboard" replace />;
  }

  const sharedRoutes = ['/inbox', '/account-settings', '/proposals'];
  const isSharedRoute = sharedRoutes.some(route => location.pathname === route || location.pathname.startsWith(`${route}/`));
  if (!isClient && isClientRoute && !isSharedRoute) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

